import QuerySelector from "../decorators/query-selector"
import DomUtils from "../utils/dom-utils"
import OnEvent from "../decorators/on-event"
import HotlistStorage from "../decorators/hotlist-storage"
import BindClass from "../decorators/bind-to-class"
import Routing from "../common/routing"
import Singleton from "../decorators/singleton"
import ListService from "../services/list-service"

const HIDE: string = 'hide'

export default class ListOptions {

    @HotlistStorage
    private hotlistStorage: any

    @QuerySelector('[list-name]')
    private listName: HTMLInputElement

    @QuerySelector('[save-hl-name]')
    private hlNameSave: HTMLDivElement

    @QuerySelector('[list-options]')
    private listOptions: HTMLDivElement

    @QuerySelector('[share-pod]')
    private sharePod: HTMLDivElement

    @BindClass('open')
    private openPopup: boolean = false

    @BindClass('popup-open')
    private bodyPopup: boolean = false

    @Singleton
    private routing: Routing

    @Singleton
    private listService: ListService

    @OnEvent({
        selector: '[rename-list]'
    })
    private renameList(): void {
        this.listName.select()
        this.openPopup = false
    }

    @OnEvent({
        selector: '[invite-others]'
    })
    private inviteOthers(): void {
        this.sharePod.scrollIntoView({ behavior: 'smooth' })
        this.openPopup = false
    }

    @OnEvent({
        selector: '[leave-list]'
    })
    public leaveList(): void {
        this.routing.routeToId(this.listService.leaveList())
        this.openPopup = false
    }

    @OnEvent({
        selector: '[list-name]',
        eventNames: [ 'focus' ]
    })
    private focusListName(): void {
        DomUtils.swapElementsClass(this.listOptions, this.hlNameSave, HIDE)
    }

    @OnEvent({
        selector: '[list-name]',
        eventNames: [ 'blur' ]
    })
    private blurListName(): void {
        DomUtils.swapElementsClass(this.hlNameSave, this.listOptions, HIDE)
    }


    @OnEvent({
        selector: '[question-leave]'
    })
    private areYouSureLeave(): void {
        this.bodyPopup = true
        this.openPopup = true
    }


    @OnEvent({
        selector: '[cancel-leave]'
    })
    private cancelLeave(): void {
        this.bodyPopup = false
        this.openPopup = false
    }
}